export default "__VITE_ASSET__82dbf26d__"